import { useStore } from "@nanostores/react";
import { ReactElement } from "react";

import {
  $zoomLevel,
  zoomIn,
  zoomOut,
  zoomToFit,
} from "../../stores/graph/ui.ts";
import { Button } from "../catalyst/Button";
import { FloatingTool } from "./FloatingTool.tsx";

export const FloatingZoomControls = (): ReactElement => {
  const zoom = useStore($zoomLevel);

  const handleZoomToFitClick = (): void => {
    zoomToFit();
  };

  const handleZoomInClick = (): void => {
    zoomIn();
  };

  const handleZoomOutClick = (): void => {
    zoomOut();
  };

  const zoomIcon = (
    <span className="cursor-pointer text-xs text-zinc-400 hover:text-zinc-200">
      {(zoom * 100).toFixed(0)}%
    </span>
  );

  const zoomContent = (
    <div className="ring-.75 min-w-[140px] rounded-lg bg-zinc-900/90 p-3 shadow-lg ring-zinc-600">
      <div className="flex flex-col space-y-1">
        <Button
          className="w-full !justify-start font-normal"
          onClick={handleZoomInClick}
          plain
          size="sm"
        >
          Zoom In
        </Button>
        <Button
          className="w-full !justify-start font-normal"
          onClick={handleZoomOutClick}
          plain
          size="sm"
        >
          Zoom Out
        </Button>
        <Button
          className="w-full !justify-start font-normal"
          onClick={handleZoomToFitClick}
          plain
          size="sm"
        >
          Zoom to Fit
        </Button>
      </div>
    </div>
  );

  return <FloatingTool icon={zoomIcon}>{zoomContent}</FloatingTool>;
};
